import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Blog = styled.div`
  width: 50%;
  height: 300px;
  display: flex;
  flex-direction: row;
  align-items:center;
  justify-content: space-between;
  background-color: #3d3256c5;
  border-radius: 1%;
  margin: 5px;
  &:hover{
        background-color: #685691c5;
    }

  @media (max-width: 600px) {
       
       width: 90%;
       height: 150px;
  }

  @media (min-width: 600px) and (max-width: 900px) {
      
    width: 80%;
    height: 175px;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
      
    width: 70%;
    height: 200px;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
      
    width: 60%;
    height: 250px;
  }
`;

const BlogImageArea = styled.div`
  width: 40%;
  height: 275px;
  display: flex;
  flex-direction: column;
  align-items:center;
  background-color: #3d3256c5;

  &:hover{
        cursor: pointer;
    }

    @media (max-width: 600px) {
       height: 150px;
  }

  @media (min-width: 600px) and (max-width: 900px) {
    height: 175px;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
    height: 200px;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
    height: 250px;
  }
`;

const BlogTextArea = styled.div`
  width: 60%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items:center;
  background-color: #3d3256c5;

  &:hover{
        cursor: pointer;
    }



`;

const BlogTitle = styled.p`
 font-size: 1vw;
 font-weight: bold;
 color: white;
 margin: 20px;
 text-align: center;
  width: 60%;
 &:hover{
        cursor: pointer;
        background-color: #685691c5;
    }

    @media (max-width: 600px) {
  font-size: 2vw;
  }

  @media (min-width: 600px) and (max-width: 900px) {
    font-size: 1.85vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
    font-size: 1.55vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
    font-size: 1.25vw;
  }

`;

const Deleteicon = styled.p`
 font-size: 1vw;
 font-weight: bold;
 color: white;
 margin: 20px;

 &:hover{
        cursor: pointer;
        background-color: #685691c5;
    }

    @media (max-width: 600px) {
  font-size: 2vw;
  }

  @media (min-width: 600px) and (max-width: 900px) {
    font-size: 1.85vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
    font-size: 1.55vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
    font-size: 1.25vw;
  }

`;

const BlogTextcont = styled.p`
 font-size: 0.85vw;
 color: white;
 margin: 5px;
 margin-left: 20px;
 margin-right: 20px;
 overflow: hidden;
 text-overflow: ellipsis;
 display: -webkit-box;
-webkit-line-clamp: 7;
-webkit-box-orient: vertical;
text-align: right;
width: 90%;

@media (max-width: 600px) {
  -webkit-line-clamp: 4;
  font-size: 1.85vw;
  }

  @media (min-width: 600px) and (max-width: 900px) {
    -webkit-line-clamp: 5;
    font-size: 1.55vw;
  }

  @media (min-width: 900px) and (max-width: 1300px) {
    -webkit-line-clamp: 5;
    font-size: 1.25vw;
  }

  @media (min-width: 1300px) and (max-width: 1700px) {
    -webkit-line-clamp: 6;
    font-size: 1.0vw;
  }
  
`;

const BlogImage = styled.img`
width: 100%;
height: 100%;
object-fit: cover;
`;

const SubmitButton = styled.button`
border-radius: 5cm;
border: solid 5px #211931;
background-color: #ffffff;
color: #211931;
font-size: 1.0vw;
font-weight: bold;
padding: 10px;
margin-bottom: 10px;
min-width: 8vw;
&:hover{
  background-color: #c0c0c0;
  cursor: pointer;
}
&:active{
  background-color: white;
}
`;

export function BlogComp(props){
  const navigate = useNavigate();
  const [deletemsg, setDeletemsg] = useState(false)

  function handleClick(props) {
    if(props.editable){
      navigate("/admin",{ replace: false, state: {"title":props.title,"content":props.content,"image":props.image, "id":props.id} });
    }else{
      navigate("/viewblog/" + String(props.id) ,{ replace: false, state: {"title":props.title,"content":props.content,"image":props.image} });
    }
  }

  async function delete_blog(){
    const response = await axios.post(
      'https://salwa-amer-backend.onrender.com/remove_blog',
      { "id": props.id },
      { headers: { 'Content-Type': 'application/json' } }
    )
    console.log(response.data)
    window.location.reload(false);
  }

    return(
        <Blog >
            <BlogImageArea onClick={() => handleClick(props)}>
                <BlogImage src={props.image}/>
            </BlogImageArea>
            
              {deletemsg?<>
              
              <BlogTextArea>
                  <BlogTitle>
                          هل انت متأكد من ازالة هذا المنشور؟
                  </BlogTitle>
                  <SubmitButton onClick={()=>{delete_blog();}}>نعم</SubmitButton>
                  <SubmitButton onClick={()=>{setDeletemsg(false)}} >لا</SubmitButton>
              </BlogTextArea>
              </>:
              <>
            <BlogTextArea onClick={() => handleClick(props)}>
            <BlogTitle>
                    {props.title}
            </BlogTitle>
            <BlogTextcont>
                    {props.content.replace(/(<([^>]+)>)/ig, '')}
            </BlogTextcont>
            </BlogTextArea>
            </>}
            {props.editable?<><Deleteicon onClick={()=>{setDeletemsg(true)}}>🗑</Deleteicon></>:<></>}
        </Blog>
    )
}